// Заявки › partidi — one row per batch_id with approve / pause for the whole batch.

import { useBatchAction } from './useQueryBatches.js';
import { shortBatch, type BatchSummary } from './queriesModel.js';

export function BatchPanel({
  batches,
  verticalName,
  selected,
  onSelect,
}: {
  batches: BatchSummary[];
  verticalName: (key: string) => string;
  selected: string | null;
  onSelect: (batchId: string | null) => void;
}) {
  const act = useBatchAction();
  if (batches.length === 0) return null;

  return (
    <div className="adm__batches">
      <div className="adm__section-header">
        <h3 className="adm__h">Партиди от „Нова ниша“</h3>
        <span className="adm__sub">
          Черновите не се пускат, докато партидата не бъде одобрена. „Спри“ спира всички заявки от
          партидата.
        </span>
      </div>
      <div className="adm__tablewrap">
        <table className="adm__table">
          <thead>
            <tr>
              <th>партида</th>
              <th>ниша</th>
              <th>град</th>
              <th className="adm__num">общо</th>
              <th className="adm__num">чернови</th>
              <th className="adm__num">активни</th>
              <th className="adm__num">спрени</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {batches.map((batch) => (
              <tr
                key={batch.batch_id}
                className={selected === batch.batch_id ? 'adm__row--selected' : ''}
              >
                <td>
                  <code>{shortBatch(batch.batch_id)}</code>
                </td>
                <td>{verticalName(batch.vertical_key)}</td>
                <td>{batch.city_key}</td>
                <td className="adm__num">{batch.total}</td>
                <td className="adm__num">{batch.draft}</td>
                <td className="adm__num">{batch.active}</td>
                <td className="adm__num">{batch.paused}</td>
                <td className="adm__cell-actions">
                  <button
                    type="button"
                    className="adm__resolve-btn"
                    disabled={batch.draft + batch.paused === 0 || act.isPending}
                    onClick={() => act.mutate({ batchId: batch.batch_id, action: 'approve' })}
                  >
                    Одобри
                  </button>
                  <button
                    type="button"
                    className="adm__json-btn"
                    disabled={batch.active === 0 || act.isPending}
                    onClick={() => act.mutate({ batchId: batch.batch_id, action: 'pause' })}
                  >
                    Спри
                  </button>
                  <button
                    type="button"
                    className="adm__json-btn"
                    onClick={() => onSelect(selected === batch.batch_id ? null : batch.batch_id)}
                  >
                    {selected === batch.batch_id ? 'Всички' : 'Покажи'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {act.isError ? <p className="adm__err">{(act.error as Error).message}</p> : null}
    </div>
  );
}
